<template>
  <div class="mt-4 leyend-container">
    <p class="text">
      <i class="fa fa-user"></i> Estudiante: Es requerido añadir un estudiante a
      la SAEE-12b.
    </p>
    <p class="text mb-0">
      <i class="fa fa-users"></i> Grupo: Es requerido añadir más de un
      estudiante a la SAEE-12b.
    </p>
  </div>
</template>

<script>
export default {
  name: "StudentLeyend"
};
</script>

<style lang="scss" scoped>
.leyend-container {
  background-color: #f7f7f7;
  padding: 20px;
}

.text {
  color: #878e95;
}
</style>
